import {
  BoldIcon,
  CodeIcon,
  CrossReferenceIcon,
  HeadingIcon,
  ItalicIcon,
  LinkIcon,
  ListOrderedIcon,
  ListUnorderedIcon,
  MentionIcon,
  QuoteIcon,
  TasklistIcon,
} from '@primer/octicons-react'
import {ActionBar} from '@primer/react'
import type React from 'react'
import {memo, use} from 'react'

import {MarkdownEditorContext} from './MarkdownEditorContext'
import {SavedRepliesButton} from './SavedReplies'
import styles from './Toolbar.module.css'
import {ToolbarButton} from './ToolbarButton'

export const DefaultToolbarButtons = memo(() => {
  const {formattingToolsRef} = use(MarkdownEditorContext)

  // Important: do not replace `() => ref.current?.format()` with `ref.current?.format` - it will refer to an outdated ref.current!
  return (
    <>
      <ToolbarButton onClick={() => formattingToolsRef.current?.header()} icon={HeadingIcon} aria-label="Heading" />
      <ToolbarButton onClick={() => formattingToolsRef.current?.bold()} icon={BoldIcon} aria-label="Bold" />
      <ToolbarButton onClick={() => formattingToolsRef.current?.italic()} icon={ItalicIcon} aria-label="Italic" />
      <ToolbarButton onClick={() => formattingToolsRef.current?.quote()} icon={QuoteIcon} aria-label="Quote" />
      <ToolbarButton onClick={() => formattingToolsRef.current?.code()} icon={CodeIcon} aria-label="Code" />
      <ToolbarButton onClick={() => formattingToolsRef.current?.link()} icon={LinkIcon} aria-label="Link" />

      <ActionBar.Divider />

      <ToolbarButton
        onClick={() => formattingToolsRef.current?.unorderedList()}
        icon={ListUnorderedIcon}
        aria-label="Unordered list"
      />
      <ToolbarButton
        onClick={() => formattingToolsRef.current?.orderedList()}
        icon={ListOrderedIcon}
        aria-label="Numbered list"
      />
      <ToolbarButton
        onClick={() => formattingToolsRef.current?.taskList()}
        icon={TasklistIcon}
        aria-label="Task list"
      />

      <ActionBar.Divider />

      <ToolbarButton onClick={() => formattingToolsRef.current?.mention()} icon={MentionIcon} aria-label="Mention" />
      <ToolbarButton
        onClick={() => formattingToolsRef.current?.reference()}
        icon={CrossReferenceIcon}
        aria-label="Reference"
      />
      <SavedRepliesButton />
    </>
  )
})
DefaultToolbarButtons.displayName = 'MarkdownEditor.DefaultToolbarButtons'

export const CoreToolbar = ({children}: {children?: React.ReactNode}) => {
  return (
    <ActionBar aria-label="Formatting tools" className={styles.toolbar} gap="none">
      {children}
    </ActionBar>
  )
}

export const Toolbar = ({children}: {children?: React.ReactNode}) => <CoreToolbar>{children}</CoreToolbar>
Toolbar.displayName = 'MarkdownEditor.Toolbar'

try{ CoreToolbar.displayName ||= 'CoreToolbar' } catch {}